module.exports = __webpack_public_path__ + "img/0Q3C0560_WoodMatted_MockedUp.47470159.jpg";